import Vue from 'vue';
import Component from 'vue-class-component';
import { analytics, LogEvent } from '@/common/logs';

export const PAGE_TRACKING = 'plPageTrack';

@Component
export default class LogPageEventMixin extends Vue {
  get trackPageParams (): LogEvent | string | null {
    // @ts-ignore
    return this[PAGE_TRACKING] || null;
  }

  created () {
    if (!this.trackPageParams) {
      return;
    }

    const isOnlyName = typeof this.trackPageParams === 'string';
    const params = {
      // Here is TypeScript error because of the spreading trackPageParams which may not be object despite
      // type guard in the start of the method
      // @ts-ignore
      ...(isOnlyName ? { name: this.trackPageParams } : this.trackPageParams),
      enter: true,
    };

    analytics.trackPageEvent(params);
  }

  beforeDestroy () {
    if (!this.trackPageParams) {
      return;
    }

    const isOnlyName = typeof this.trackPageParams === 'string';
    const params = {
      // @ts-ignore
      ...(isOnlyName ? { name: this.trackPageParams } : this.trackPageParams),
      enter: false,
    };

    analytics.trackPageEvent(params);
  }
}

// Keep here so events can be imported from this file with mixin
export { PAGE_EVENTS } from '@/common/logs';
